import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// Layouts e Páginas
import AdminSolicitacoesPage from "../pages/SuperAdmin/AdminSolicitacoesPage";
import AdminAnaliseSolicitacaoPage from "../pages/SuperAdmin/AdminAnaliseSolicitacaoPage";
import AdminGarantiasAtivasPage from "../pages/SuperAdmin/AdminGarantiasAtivasPage";
import AdminFaturamentoPage from "../pages/SuperAdmin/AdminFaturamentoPage"; 
import ClientLayout from "../pages/Layouts/ClientLayout";
import SuperAdminPage from "../pages/SuperAdmin/SuperAdminPage";
import LoginPage from "../pages/Login/LoginPage";
import ForgotPasswordPage from "../pages/Auth/ForgotPasswordPage";
import ChangePasswordPage from "../pages/Auth/ChangePasswordPage";
import InviteRegisterPage from "../pages/Auth/InviteRegisterPage";
import SetupInterno from "../pages/Auth/SetupInterno"; 
import DashboardPage from "../pages/Dashboard/DashboardPage";
import MinhaCarteiraPage from "../pages/Dashboard/MinhaCarteiraPage"; 
import FaturasPage from "../pages/Dashboard/FaturasPage"; 
import SimuladorPage from "../pages/Dashboard/SimuladorPage";
import SolicitacoesPage from "../pages/Dashboard/SolicitacoesPage"; 
import NovaSolicitacaoPage from "../pages/Dashboard/NovaSolicitacaoPage"; 
import SolicitacaoDetalhesPage from "../pages/Dashboard/SolicitacaoDetalhesPage"; 
import SettingsPage from "../pages/Settings/SettingsPage";
import AjudaPage from "../pages/Ajuda/AjudaPage";
import SubscriptionPage from "../pages/Subscription/SubscriptionPage";
import NotFoundPage from "../pages/NotFound/NotFoundPage";
import AdminDashboard from "../pages/SuperAdmin/AdminDashboard";
import AdminCompanies from "../pages/SuperAdmin/AdminCompanies";
import BlockedAccountPage from "../pages/Status/BlockedAccountPage";
import AdminTeamPage from "../pages/SuperAdmin/AdminEquipePage"; 
import AdminModelosParecerPage from "../pages/SuperAdmin/AdminModelosParecerPage"; 
import AdminIntegracoesPage from "../pages/SuperAdmin/AdminIntegracoesPage";
import AdminHealthPage from "../pages/SuperAdmin/AdminHealthPage";
import HistoricoLocacoesPage from "../pages/Dashboard/HistoricoLocacoesPage";
import TestemunhasPage from "../pages/Client/TestemunhasPage";

// Route Guards
import ProtectedRoute from "./ProtectedRoute";
import SuperAdminRoute from "./SuperAdminRoute";

const GatewayLayout = () => {
  const { currentUser, userInfo, loading } = /** @type {any} */ (useAuth());

  if (loading) {
    return null;
  }

  if (currentUser) {
    if (userInfo?.role === 'superadmin' || userInfo?.isInternal) {
      return <Navigate to="/super-admin/dashboard" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

const AppRoutes = () => {
  return (
    <Routes>
      {/* Rotas Públicas */}
      <Route element={<GatewayLayout />}>
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Route>
      
      <Route path="/login" element={<LoginPage />} />
      <Route path="/esqueci-minha-senha" element={<ForgotPasswordPage />} />
      <Route path="/invite" element={<InviteRegisterPage />} />
      <Route path="/setup-interno/:id" element={<SetupInterno />} />
      <Route path="/conta-bloqueada" element={<BlockedAccountPage />} />
      
      <Route
        path="/auth/change-password"
        element={
          <ProtectedRoute>
            <ChangePasswordPage />
          </ProtectedRoute>
        }
      />

      {/* 👑 Rotas do Owner / Super Admin (Gestão da Real Benefícios) */}
      <Route
        path="/super-admin"
        element={
          <SuperAdminRoute>
            <SuperAdminPage />
          </SuperAdminRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="imobiliarias" element={<AdminCompanies />} />
        <Route path="requests" element={<AdminSolicitacoesPage />} /> 
        <Route path="requests/:id" element={<AdminAnaliseSolicitacaoPage />} />
        <Route path="request/:id" element={<AdminAnaliseSolicitacaoPage />} /> 
        <Route path="garantias-ativas" element={<AdminGarantiasAtivasPage />} /> 
        <Route path="historico" element={<HistoricoLocacoesPage />} />
        <Route path="faturamento" element={<AdminFaturamentoPage />} /> 
        <Route path="modelos-parecer" element={<AdminModelosParecerPage />} /> 
        <Route path="equipe" element={<AdminTeamPage />} />
        <Route path="integracoes" element={<AdminIntegracoesPage />} />
        <Route path="health" element={<AdminHealthPage />} />
      </Route>

      {/* 🚀 Rotas Protegidas do Cliente (Visão da Imobiliária Parceira) */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute allowedRoles={["admin", "gerente", "user"]}>
            <ClientLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="carteira" element={<MinhaCarteiraPage />} /> 
        <Route path="historico" element={<HistoricoLocacoesPage />} />
        <Route path="faturas" element={<FaturasPage />} /> 
        <Route path="simulador" element={<SimuladorPage />} />
        <Route path="requests" element={<SolicitacoesPage />} />
        <Route path="novo-request" element={<NovaSolicitacaoPage />} />
        <Route path="novo-request/:id" element={<NovaSolicitacaoPage />} /> 
        <Route path="requests/:id" element={<SolicitacaoDetalhesPage />} /> 
        <Route path="request/:id" element={<SolicitacaoDetalhesPage />} /> 
        <Route path="testemunhas" element={<TestemunhasPage />} />
        <Route path="assinatura" element={<SubscriptionPage />} />
        <Route path="configuracoes" element={<SettingsPage />} />
        <Route path="ajuda" element={<AjudaPage />} />
      </Route>

      {/* Rota Not Found */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;